import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  FaLock,
  FaLockOpen,
  FaPlus,
  FaTrash,
  FaUsers,
  FaUserFriends,
  FaUserPlus,
  FaUserSlash,
  FaLink,
  FaSyncAlt,
  FaEye,
  FaEyeSlash,
  FaComments,
} from "react-icons/fa";
import HomeShell from "../components/HomeShell";
import { api } from "../api/api";
// Il filtro dei candidati all'aggiunta a mano ha una sede sola nel frontend,
// accanto alla plancia (ClinicEvents.jsx), e la usa anche l'area del socio.
import { eIscrivibileAllaClinic } from "./ClinicEvents";
// L'intestazione, l'esecutore dei gesti e le pastiglie sono gli stessi
// dell'elenco: clinicShared.jsx, spostati e non copiati.
import { IntestazionePlancia, PastiglieEvento, useGestoClinic } from "./clinicShared";
// I pulsanti e i campi sono quelli di sistema (doc 07 §5.1 oro, §5.3 fantasma,
// §5.5 campi), come nella plancia.
import "../components/AdminTools.css";
import "./ClinicEvents.css";
// La finestra «Event payment» e la regola del saldo di una riga (Fetta 7).
import ClinicPaymentModal, { saldoDellIscritto } from "./ClinicPaymentModal";
// La finestra di sola lettura «Guest details» (Fetta G1).
import ClinicGuestModal from "./ClinicGuestModal";
// La bacheca di un gruppo («BOARD - CHAT» Fetta A): lo stesso componente
// della pagina del socio, con le rotte della plancia.
import { BachecaClinic } from "./ClinicBoard";

/**
 * Clinic / Off Season / Specials — la pagina di UN evento, per
 * l'amministrazione. Cantiere CLINICS / OFFSEASON, Fetta 3 «plancia a pagine»
 * (23/9/2026). Rotta /clinic-events/:id, gate ADMIN/SUPERADMIN come la plancia.
 *
 * ⚠️ NON È CODICE NUOVO: è il pannello che fino alla Fetta 3 si apriva a
 * tendina sotto la riga dell'evento in /clinic-events (ClinicEvents.jsx),
 * SPOSTATO qui con lo stesso comportamento. Ogni gesto passa ancora da
 * `esegui` e chiama le stesse rotte; l'evento si legge con GET
 * /clinic-events/:id, iscritti e sessioni con le loro rotte di sempre. Da
 * questa pagina un ADMIN o un SUPERADMIN:
 *   ne corregge nome e descrizione (le date dell'evento non si usano più dalla
 *   Fetta 3: le date vere sono quelle delle sessioni);
 *   lo APRE e lo CHIUDE — la leva del confine (DISEGNO §3);
 *   lo NASCONDE e lo rimette in vista (15/9);
 *   ne definisce i GRUPPI (crea, rinomina, rimuove);
 *   ne copia il LINK PUBBLICO (Fetta C1, 15/9/2026) — e può rigenerarlo;
 *   ne gestisce gli ISCRITTI (Fetta C2, 15/9/2026): li vede, ne aggiunge a
 *   mano, li assegna ai gruppi, li toglie dall'evento — e, sui soli OSPITI,
 *   cancella definitivamente account e dati;
 *   ne legge la SCHEDA di un ospite, in sola lettura (Fetta G1, 24/9/2026:
 *   «View Guest»). Dalla G1 la plancia NON crea più ospiti: «Add a guest» è
 *   stato tolto, e un ospite — bambino col suo tutore, o adulto per sé — si
 *   iscrive da sé dal link pubblico, accettando lui i termini;
 *   ne programma le SESSIONI per gruppo (Calendario clinic, Fetta 1,
 *   23/9/2026): giorno, ora d'inizio, ora di fine facoltativa, una nota breve.
 *
 * ⚠️ UNA PAGINA PER EVENTO, e lo stato NASCE CON LEI. Il componente vero
 * (`PaginaEvento`) è montato con `key` = id dell'indirizzo: cambiare evento
 * vuol dire smontare una pagina e montarne un'altra, con stato nuovo. Una
 * risposta lenta dell'evento di prima arriva a un componente che non c'è più
 * e non tocca l'elenco di quello nuovo (il rilievo R3 della revisione di
 * Fetta 1 non ha più luogo). Per la stessa ragione i vecchi azzeramenti «al
 * cambio d'evento» non servono più.
 *
 * I PAGAMENTI DELL'EVENTO (Fetta 7, 23/9/2026): su ogni riga il saldo e il
 * bottone «Payments», che apre la finestra ClinicPaymentModal.jsx — quota
 * scritta a mano, pagamenti, «Not due». Vivono sull'iscrizione, non sulla
 * scheda del socio.
 *
 * ⚠️ QUEL CHE QUI NON C'È, e non per dimenticanza: nessun check-in. È il
 * punto 5. (La «chat» c'è dalla Fetta A di «BOARD - CHAT», 26/9/2026: una
 * bacheca per gruppo, sotto le sessioni — v. ClinicBoard.jsx.) E nessuna «unione dei
 * doppioni»: è stata tolta dal perimetro dal committente il 15/9 — il caso
 * raro si risolve con l'iscrizione del socio dalla sua area (/clinics) più la
 * cancellazione definitiva della copia-ospite, qui sotto.
 *
 * ⚠️ IL GRUPPO DI UN ISCRITTO VIVE SULL'ISCRIZIONE (`groupId`), non dentro
 * l'array `groups` dell'evento: è la soluzione alla radice del rilievo R2 della
 * revisione di Fetta B (le tre rotte dei gruppi riscrivono l'array intero, e
 * chi ci mettesse dentro gli iscritti li vedrebbe sparire alla prima
 * operazione su un altro gruppo). Da qui la conseguenza visibile a schermo: un
 * gruppo ABITATO non si può cancellare — prima si spostano le persone.
 *
 * ⚠️ I DUE GESTI DI RIMOZIONE SONO DUE, e restano distinti apposta. «Remove
 * from event» toglie l'iscrizione e lascia in piedi l'account dell'ospite (può
 * essere iscritto altrove). «Delete guest permanently» cancella account, profilo
 * del minore e OGNI sua iscrizione: è irreversibile, vale solo sui puri ospiti —
 * mai su un socio o su chi ha una tessera — e chiede di DIGITARE una parola,
 * che il server verifica.
 *
 * ⚠️ IL LINK PUBBLICO (C1). Lo slug lo conia il SERVER e lo restituisce la
 * sola POST /clinic-events/:id/public-link, a richiesta: non viaggia
 * nell'elenco né nel dettaglio, perché lo slug È la revoca del link e si
 * mostra solo a chi deve copiarlo, quando deve copiarlo. Il link vive finché
 * l'evento è OPEN — la leva lo spegne — e «New link» lo rigenera: il vecchio
 * muore all'istante. L'URL si compone qui da `window.location.origin`, come
 * fa Login.jsx per il link d'accesso: punta all'host da cui l'admin lavora.
 *
 * ⚠️ IL CONFINE e NESSUNA SCRITTURA DAL CLIENT: come la plancia (v. il
 * cappello di ClinicEvents.jsx).
 *
 * Regole di identità grafica: doc 07 (palette, pulsanti §5, telaio §7, card
 * §8). Testi a schermo in inglese (CLAUDE.md §3.7).
 */

// LA DATA COM'È SCRITTA A SCHERMO — dalla Fetta 3 serve alle sole SESSIONI (le
// date dell'evento non si mostrano più, né qui né sulla porta pubblica).
//
// Il server parla e ascolta in AAAA-MM-GG e basta (è la forma che emette
// `<input type="date">`); qui si abbellisce per la sola lettura, e SENZA
// toccare il valore che viaggia. `new Date("2026-03-04")` è interpretata come
// UTC: si scompone la stringa a mano e si ricompone in UTC, altrimenti a ovest
// di Greenwich il giorno mostrato sarebbe quello PRIMA di quello salvato.
function dataLeggibile(iso) {
  const pezzi = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || ""));
  if (!pezzi) return String(iso || "");

  const quando = new Date(
    Date.UTC(Number(pezzi[1]), Number(pezzi[2]) - 1, Number(pezzi[3]))
  );

  return quando.toLocaleDateString("en-AU", {
    timeZone: "UTC",
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

// La parola da digitare per la cancellazione definitiva. È la stessa di
// MemberProfileModal («Type "DELETE" to confirm»), con una differenza che
// conta: lì il controllo vive solo nel browser, qui il server rifiuta senza la
// parola. Questa costante è la copia a schermo di quella del server, non il
// controllo: il controllo è là.
const PAROLA_CANCELLAZIONE = "DELETE";

// Il nome dell'iscritto, del tutore, e da quale porta è entrato — i tre dati
// con cui l'amministrazione riconosce una riga. Stanno qui, fuori dal
// componente, perché non dipendono da nulla dello stato.
function nomeIscritto(p) {
  return `${p.childFirstName || ""} ${p.childLastName || ""}`.trim() || "—";
}

// Il tutore: il nome se l'iscrizione lo porta (le porte di C2 lo scrivono), la
// casella di posta altrimenti — le iscrizioni nate da C1 hanno solo quella, e
// la casella c'è sempre.
function tutoreIscritto(p) {
  const nome = `${p.guardianFirstName || ""} ${p.guardianLastName || ""}`.trim();

  return nome || p.guardianEmail || "no parent/guardian on record";
}

// Da dove viene: `kind` dice CHE COSA è la persona (ospite o tesserato),
// `source` da quale porta è entrata. Sono due domande diverse e due campi.
function origineIscritto(p) {
  const chi = p.kind === "guest" ? "Guest" : "Club member";

  const porta =
    p.source === "public-link"
      ? "public link"
      : p.source === "member-area"
      ? "enrolled by parent"
      : p.source === "admin"
      ? "added by admin"
      : p.source === "guest-area"
      ? "enrolled from the app"
      : "unknown source";

  return `${chi} · ${porta}`;
}

// L'ADULTO OSPITE (Fetta G1): chi si è iscritto da sé dal link pubblico. Non
// ha un tutore, e la sua riga dice che cosa ha dichiarato — «Guest · Player» o
// «Guest · Coach» — al posto del tutore e della porta. `enrolledSelf` e
// `joiningAs` escono dalla sola proiezione della plancia, e solo su queste
// iscrizioni.
const JOINING_AS_A_SCHERMO = { PLAYER: "Player", COACH: "Coach" };

function adultoOspite(p) {
  return p.kind === "guest" && p.enrolledSelf === true;
}

function sottotitoloIscritto(p) {
  if (adultoOspite(p)) {
    const come = JOINING_AS_A_SCHERMO[p.joiningAs];
    return come ? `Guest · ${come}` : "Guest";
  }

  return `${tutoreIscritto(p)} · ${origineIscritto(p)}`;
}

// Di chi è l'ACCOUNT che «Delete guest» cancella: il tutore, per un bambino
// ospite; la persona stessa, per un adulto ospite.
function titolareOspite(p) {
  return adultoOspite(p) ? nomeIscritto(p) : tutoreIscritto(p);
}

// QUANTI ISCRITTI PER GRUPPO, dagli iscritti già letti: il gruppo di un
// iscritto vive sull'iscrizione (`groupId`, v. cappello), quindi si conta lì —
// non dentro l'array `groups` dell'evento, che non si tocca (R2). La chiave
// vuota è «senza gruppo». Nessuna lettura in più: la pagina ha già l'elenco
// intero (GET /clinic-events/:id/participants non ha limiti).
function conteggioPerGruppo(iscritti) {
  const conteggio = new Map();

  for (const p of iscritti) {
    const chiave = typeof p.groupId === "string" ? p.groupId : "";
    conteggio.set(chiave, (conteggio.get(chiave) || 0) + 1);
  }

  return conteggio;
}

// LE SESSIONI DI UN GRUPPO (Calendario clinic, Fetta 1, 23/9/2026).
//
// Vivono in una sottoraccolta dell'evento, `sessions`, legate al gruppo da
// `groupId` — MAI dentro l'array `groups`, per la stessa ragione di R2 (v.
// cappello): le rotte dei gruppi lo riscrivono intero e le perderebbero. Il
// vaglio vero è del server (forma HH:MM, fine dopo l'inizio, nota di al più
// 40 caratteri, 100 sessioni per gruppo); qui si evita solo di far partire una
// chiamata che si sa già rifiutata.
const SESSIONE_VUOTA = { date: "", startTime: "", endTime: "", notes: "" };
const SESSIONE_NOTE_MAX = 40;

// «18:30» oppure «18:30–20:00». Le ore viaggiano già in HH:MM sulle 24 ore.
function orarioSessione(s) {
  return s.endTime ? `${s.startTime}–${s.endTime}` : s.startTime;
}

// La cortesia del client sull'INSIEME: se c'è una fine, viene dopo l'inizio.
// HH:MM a due cifre si confronta come stringa, come fa il server.
function erroreOrariSessione(s) {
  if (s.endTime && s.endTime <= s.startTime) {
    return "Session end time must be after the start time";
  }
  return null;
}

// La rotta monta questa: legge l'id dall'indirizzo e monta la pagina vera con
// `key` = id (v. cappello, «una pagina per evento»).
export default function ClinicEventDetail() {
  const { id } = useParams();

  return <PaginaEvento key={id} idEvento={id} />;
}

function PaginaEvento({ idEvento }) {
  const navigate = useNavigate();

  // L'EVENTO di questa pagina, com'è sul server: `null` finché non è letto.
  // `nonDisponibile` è l'esito di una lettura non riuscita — id inesistente o
  // evento non leggibile: la pagina dice una frase sola, senza distinguere.
  const [evento, setEvento] = useState(null);
  const [caricamento, setCaricamento] = useState(true);
  const [nonDisponibile, setNonDisponibile] = useState(false);

  const { azioneInCorso, erroreAzione, setErroreAzione, esegui } = useGestoClinic();

  // La BOZZA di modifica dell'evento. La bozza è separata dall'evento: finché
  // non si salva, ciò che è a schermo non è ciò che è sul server, e le due cose
  // non devono confondersi.
  const [bozza, setBozza] = useState(null);
  const [nuovoGruppo, setNuovoGruppo] = useState("");

  // IL LINK PUBBLICO dell'evento (C1): l'URL intero, già composto, oppure null
  // finché l'admin non lo chiede. `linkCopiato` è il solo riscontro del gesto
  // di copia («Copied»).
  const [linkPubblico, setLinkPubblico] = useState(null);
  const [linkCopiato, setLinkCopiato] = useState(false);

  // GLI ISCRITTI dell'evento (C2). Si leggono all'apertura della pagina e
  // valgono per QUESTO solo evento.
  const [iscritti, setIscritti] = useState([]);
  const [caricamentoIscritti, setCaricamentoIscritti] = useState(false);
  const [erroreIscritti, setErroreIscritti] = useState(null);

  // LE SESSIONI dell'evento (Fetta 1 del calendario), sul modello degli
  // iscritti. `bozzeSessione` è il modulo d'aggiunta di ciascun gruppo (chiave
  // = id del gruppo); `modificaSessione` è la bozza della sola sessione in
  // modifica — una per volta, come la bozza dell'evento: finché non si salva,
  // ciò che è a schermo non è sul server.
  const [sessioni, setSessioni] = useState([]);
  const [caricamentoSessioni, setCaricamentoSessioni] = useState(false);
  const [erroreSessioni, setErroreSessioni] = useState(null);
  const [bozzeSessione, setBozzeSessione] = useState({});
  const [modificaSessione, setModificaSessione] = useState(null);

  // LE BACHECHE APERTE («BOARD - CHAT» Fetta A): gli id dei gruppi di cui la
  // bacheca è aperta a schermo. Chiusa, la bacheca non si monta e non si
  // rilegge a intervalli: con molti gruppi, solo quelle che si guardano.
  const [bachecheAperte, setBachecheAperte] = useState([]);

  const apriChiudiBacheca = (gruppoId) =>
    setBachecheAperte((prima) =>
      prima.includes(gruppoId)
        ? prima.filter((id) => id !== gruppoId)
        : [...prima, gruppoId]
    );

  // L'AGGIUNTA A MANO: se il modulo del socio è aperto ("socio") o no. Il
  // modulo dell'ospite non c'è più dalla Fetta G1.
  const [aggiunta, setAggiunta] = useState(null);

  // LA RICERCA DEL SOCIO. L'anagrafica si legge UNA volta sola e su richiesta —
  // solo quando l'admin apre il modulo — perché `GET /users` è la lista intera
  // del club: non è roba da caricare all'apertura di una pagina che quasi
  // sempre non ne ha bisogno. `null` vuol dire «non ancora letta».
  const [anagrafica, setAnagrafica] = useState(null);
  const [ricercaSocio, setRicercaSocio] = useState("");

  // LA FINESTRA DEI PAGAMENTI (Fetta 7): l'id dell'iscrizione di cui è aperta,
  // o `null`. Si tiene l'id e non la riga: la riga si rilegge dall'elenco, che
  // la finestra aggiorna a ogni scrittura.
  const [pagamentiDi, setPagamentiDi] = useState(null);

  // LA SCHEDA DELL'OSPITE (Fetta G1): l'id dell'iscrizione di cui è aperta la
  // finestra «Guest details», o `null`. Come per i pagamenti, la riga si
  // rilegge dall'elenco.
  const [schedaOspiteDi, setSchedaOspiteDi] = useState(null);

  // GLI ISCRITTI DI UN EVENTO (C2). La rotta è ADMIN/SUPERADMIN come tutte le
  // altre della plancia; un guasto qui non spegne il resto della pagina — si
  // dice e basta, perché titolo, gruppi e link restano utilizzabili.
  const caricaIscritti = useCallback(async (eventoId) => {
    setCaricamentoIscritti(true);
    setErroreIscritti(null);

    try {
      const elenco = await api.get(`/clinic-events/${eventoId}/participants`);
      setIscritti(Array.isArray(elenco) ? elenco : []);
    } catch (err) {
      setErroreIscritti(
        "The list of participants could not be loaded. Reload the page to try again."
      );
      setIscritti([]);
    } finally {
      setCaricamentoIscritti(false);
    }
  }, []);

  // LE SESSIONI DI UN EVENTO (Fetta 1 del calendario), calco di
  // `caricaIscritti`: un guasto qui non spegne il resto della pagina.
  const caricaSessioni = useCallback(async (eventoId) => {
    setCaricamentoSessioni(true);
    setErroreSessioni(null);

    try {
      const elenco = await api.get(`/clinic-events/${eventoId}/sessions`);
      setSessioni(Array.isArray(elenco) ? elenco : []);
    } catch (err) {
      setErroreSessioni(
        "The list of sessions could not be loaded. Reload the page to try again."
      );
      setSessioni([]);
    } finally {
      setCaricamentoSessioni(false);
    }
  }, []);

  // L'APERTURA DELLA PAGINA — ciò che faceva l'apertura della tendina: si
  // legge l'evento (GET /clinic-events/:id, che risponde anche per un evento
  // nascosto), si prepara la bozza, e si leggono iscritti e sessioni con l'id
  // che il server ha confermato. Un evento che non si legge non chiama altro.
  useEffect(() => {
    const leggi = async () => {
      setCaricamento(true);

      try {
        const letto = await api.get(`/clinic-events/${encodeURIComponent(idEvento)}`);

        if (!letto || !letto.id) {
          setNonDisponibile(true);
          return;
        }

        setEvento(letto);
        setBozza({
          title: letto.title || "",
          description: letto.description || "",
        });
        caricaIscritti(letto.id);
        caricaSessioni(letto.id);
      } catch (err) {
        setNonDisponibile(true);
      } finally {
        setCaricamento(false);
      }
    };

    leggi();
  }, [idEvento, caricaIscritti, caricaSessioni]);

  // L'evento aggiornato prende il posto di quello a schermo. Le rotte
  // rispondono con l'evento INTERO, quindi non serve rileggere: ciò che è a
  // schermo è ciò che il server ha appena scritto.
  const sostituisci = (aggiornato) => {
    if (!aggiornato || !aggiornato.id) return;
    setEvento((precedente) =>
      precedente && precedente.id === aggiornato.id ? aggiornato : precedente
    );
  };

  // I soli gruppi cambiano: le tre rotte dei gruppi rispondono con l'array
  // aggiornato, non con l'evento.
  const sostituisciGruppi = (eventoId, gruppi) => {
    setEvento((precedente) =>
      precedente && precedente.id === eventoId
        ? { ...precedente, groups: Array.isArray(gruppi) ? gruppi : [] }
        : precedente
    );
  };

  // --- IL LINK PUBBLICO (C1) --------------------------------------------

  // Negli appunti, se il browser lo permette. Il campo di sola lettura qui
  // sotto resta comunque a schermo: chi non può usare gli appunti (contesto non
  // sicuro, permesso negato) seleziona e copia a mano, e nessun errore serve.
  const copiaNegliAppunti = async (url) => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(url);
        setLinkCopiato(true);
      }
    } catch (_) {
      /* appunti non disponibili: il campo di sola lettura basta. */
    }
  };

  // Chiede lo slug al server (che lo conia se manca) e compone l'URL. Con
  // `rigenera` il server ne conia uno nuovo e il vecchio link muore: per
  // questo, e solo per questo, si chiede conferma — non è un gesto che si
  // disfa, e chi ha già ricevuto il vecchio link non entra più.
  const mostraLink = async (evento, rigenera) => {
    if (rigenera && !window.confirm(
      "Generate a new public link? The current link will stop working immediately."
    )) {
      return;
    }

    setLinkCopiato(false);

    // Già a schermo e non si rigenera: si ricopia e basta, senza chiamare il
    // server per un valore che si ha già in mano.
    if (!rigenera && linkPubblico) {
      copiaNegliAppunti(linkPubblico);
      return;
    }

    await esegui(
      `link-${evento.id}`,
      () =>
        api.post(
          `/clinic-events/${evento.id}/public-link`,
          rigenera ? { regenerate: true } : {}
        ),
      (risposta) => {
        const percorso = risposta && typeof risposta.publicPath === "string"
          ? risposta.publicPath
          : "";
        if (!percorso) return;
        const url = `${window.location.origin}${percorso}`;
        setLinkPubblico(url);
        copiaNegliAppunti(url);
      }
    );
  };

  const salvaModifica = (evento) => {
    if (!bozza) return;

    if (!bozza.title.trim()) {
      setErroreAzione("Event title is required");
      return;
    }

    esegui(
      "modifica",
      () =>
        api.put(`/clinic-events/${evento.id}`, {
          title: bozza.title.trim(),
          description: bozza.description.trim(),
        }),
      sostituisci
    );
  };

  // --- LA LEVA ----------------------------------------------------------
  //
  // Aprire e chiudere è REVERSIBILE — è un interruttore, non un gesto
  // distruttivo — e la doppia conferma dell'app è riservata a ciò che non si
  // può disfare. Dalla Fetta 4 però «Close» chiede UNA conferma, perché la
  // chiusura ha effetti che si vedono fuori dalla plancia (il link pubblico
  // muore, i soci non vedono più l'evento né il suo calendario): la conferma
  // lo dice prima di premere. «Reopen» resta senza conferma.
  const cambiaStato = (evento) => {
    const prossimo = evento.status === "OPEN" ? "CLOSED" : "OPEN";

    if (prossimo === "CLOSED" && !window.confirm(
      "Close this event? The public link stops working and members will no longer see it or its calendar. You can reopen it later."
    )) {
      return;
    }

    esegui(
      `stato-${evento.id}`,
      () => api.patch(`/clinic-events/${evento.id}/status`, { status: prossimo }),
      sostituisci
    );
  };

  // --- LA SECONDA LEVA: NASCONDI / MOSTRA (15/9) ------------------------
  //
  // «Hide» è solo visibilità: l'evento esce dall'elenco della plancia e non
  // gli succede altro — niente cancellazioni, di nessun genere. È reversibile
  // come l'apri/chiudi e non chiede conferma (né «Hide» né «Unhide»). Il
  // server ammette «Hide» sul solo evento CHIUSO (la pagina offre il bottone
  // solo lì) e rifiuta di riaprire un evento nascosto: per quello si passa da
  // «Unhide».
  //
  // Dalla Fetta 3 si RESTA su questa pagina, dopo «Hide» come dopo «Unhide»:
  // la voce si sostituisce e la pagina mostra la pastiglia HIDDEN e «Unhide
  // event». È l'elenco della plancia che, rileggendo, non la mostrerà più.
  const cambiaVisibilita = (evento, nascosto) => {
    esegui(
      `nascosto-${evento.id}`,
      () => api.patch(`/clinic-events/${evento.id}/hidden`, { hidden: nascosto }),
      sostituisci
    );
  };

  // --- I GRUPPI ---------------------------------------------------------

  const creaGruppo = async (evento) => {
    if (!nuovoGruppo.trim()) {
      setErroreAzione("Group name is required");
      return;
    }

    const riuscito = await esegui(
      "gruppo-nuovo",
      () => api.post(`/clinic-events/${evento.id}/groups`, { name: nuovoGruppo.trim() }),
      (risposta) => sostituisciGruppi(evento.id, risposta && risposta.groups)
    );

    if (riuscito) setNuovoGruppo("");
  };

  const rinominaGruppo = (evento, gruppo) => {
    const nome = window.prompt("Group name:", gruppo.name);

    // Annullato (null) o lasciato identico: non si chiama il server per nulla.
    if (nome === null) return;
    if (nome.trim() === gruppo.name) return;

    esegui(
      `gruppo-${gruppo.id}`,
      () =>
        api.patch(`/clinic-events/${evento.id}/groups/${gruppo.id}`, {
          name: nome.trim(),
        }),
      (risposta) => sostituisciGruppi(evento.id, risposta && risposta.groups)
    );
  };

  // UNA conferma sola, non due. La doppia conferma scritta dell'app è per i
  // gesti irreversibili su dati di persone (il delete di un membro); un gruppo,
  // in questa fetta, è un contenitore VUOTO — le iscrizioni non esistono
  // ancora — e rifarlo costa il nome che si è appena letto.
  const rimuoviGruppo = (evento, gruppo) => {
    // La bacheca del gruppo se ne va con lui (BAC-12): lo si dice prima.
    if (
      !window.confirm(
        `Remove group "${gruppo.name}"? Its board messages will be deleted too.`
      )
    )
      return;

    esegui(
      `gruppo-${gruppo.id}`,
      () => api.del(`/clinic-events/${evento.id}/groups/${gruppo.id}`),
      (risposta) => sostituisciGruppi(evento.id, risposta && risposta.groups)
    );
  };

  // --- LE SESSIONI (Calendario clinic, Fetta 1) ---------------------------
  //
  // Ogni scrittura passa da `esegui` (un gesto in volo per volta) e, a fine
  // gesto, RILEGGE l'elenco: l'ordine per giorno e ora lo dà il server, e ciò
  // che è a schermo resta ciò che il server ha davvero scritto.

  const bozzaSessioneDi = (gruppoId) => bozzeSessione[gruppoId] || SESSIONE_VUOTA;

  const poniBozzaSessione = (gruppoId, campo, valore) => {
    setBozzeSessione((precedenti) => ({
      ...precedenti,
      [gruppoId]: { ...(precedenti[gruppoId] || SESSIONE_VUOTA), [campo]: valore },
    }));
  };

  const aggiungiSessione = async (evento, gruppo) => {
    const nuova = bozzaSessioneDi(gruppo.id);

    if (!nuova.date || !nuova.startTime) {
      setErroreAzione("A session needs a date and a start time.");
      return;
    }

    const incoerenza = erroreOrariSessione(nuova);
    if (incoerenza) {
      setErroreAzione(incoerenza);
      return;
    }

    const riuscito = await esegui(
      `sessione-nuova-${gruppo.id}`,
      () =>
        api.post(`/clinic-events/${evento.id}/sessions`, {
          groupId: gruppo.id,
          date: nuova.date,
          startTime: nuova.startTime,
          endTime: nuova.endTime,
          notes: nuova.notes.trim(),
        }),
      () => caricaSessioni(evento.id)
    );

    if (riuscito) {
      setBozzeSessione((precedenti) => ({ ...precedenti, [gruppo.id]: SESSIONE_VUOTA }));
    }
  };

  // LA MODIFICA IN LINEA, sul calco della bozza dell'evento: una copia a parte
  // dei quattro campi, «Save» la manda, «Discard» la butta. Il gruppo non è fra
  // i campi (D8): per spostare una sessione la si cancella e la si ricrea.
  const avviaModificaSessione = (s) => {
    setErroreAzione(null);
    setModificaSessione({
      id: s.id,
      date: s.date || "",
      startTime: s.startTime || "",
      endTime: s.endTime || "",
      notes: s.notes || "",
    });
  };

  const salvaSessione = async (evento) => {
    const bozzaS = modificaSessione;
    if (!bozzaS) return;

    if (!bozzaS.date || !bozzaS.startTime) {
      setErroreAzione("A session needs a date and a start time.");
      return;
    }

    const incoerenza = erroreOrariSessione(bozzaS);
    if (incoerenza) {
      setErroreAzione(incoerenza);
      return;
    }

    const riuscito = await esegui(
      `sessione-${bozzaS.id}`,
      () =>
        api.patch(`/clinic-events/${evento.id}/sessions/${bozzaS.id}`, {
          date: bozzaS.date,
          startTime: bozzaS.startTime,
          endTime: bozzaS.endTime,
          notes: bozzaS.notes.trim(),
        }),
      () => caricaSessioni(evento.id)
    );

    if (riuscito) setModificaSessione(null);
  };

  // «Cancel session» ELIMINA davvero (D3): una conferma sola, come la
  // rimozione di un gruppo — rifarla costa i quattro campi appena letti.
  const cancellaSessione = (evento, s) => {
    if (!window.confirm("Cancel this session? It will be removed.")) return;

    esegui(
      `sessione-${s.id}`,
      () => api.del(`/clinic-events/${evento.id}/sessions/${s.id}`),
      () => {
        if (modificaSessione && modificaSessione.id === s.id) setModificaSessione(null);
        caricaSessioni(evento.id);
      }
    );
  };

  // I quattro campi di una sessione, nel modulo d'aggiunta e nella modifica:
  // si scrivono una volta e si montano due.
  const campiSessione = (valori, poni, chiave) => (
    <div className="qpsc-clinic__session-fields">
      <label className="qpsc-field qpsc-clinic__session-field">
        <span className="qpsc-field__label">Date</span>
        <input
          type="date"
          className="qpsc-input"
          value={valori.date}
          onChange={(e) => poni("date", e.target.value)}
          disabled={azioneInCorso !== null}
          aria-label={`Session date for ${chiave}`}
        />
      </label>

      <label className="qpsc-field qpsc-clinic__session-field">
        <span className="qpsc-field__label">Start</span>
        <input
          type="time"
          className="qpsc-input"
          value={valori.startTime}
          onChange={(e) => poni("startTime", e.target.value)}
          disabled={azioneInCorso !== null}
          aria-label={`Start time for ${chiave}`}
        />
      </label>

      <label className="qpsc-field qpsc-clinic__session-field">
        <span className="qpsc-field__label">End (optional)</span>
        <input
          type="time"
          className="qpsc-input"
          value={valori.endTime}
          onChange={(e) => poni("endTime", e.target.value)}
          disabled={azioneInCorso !== null}
          aria-label={`End time for ${chiave}`}
        />
      </label>

      <label className="qpsc-field qpsc-clinic__session-field qpsc-clinic__session-field--notes">
        <span className="qpsc-field__label">Notes / place</span>
        <input
          type="text"
          className="qpsc-input"
          value={valori.notes}
          onChange={(e) => poni("notes", e.target.value)}
          placeholder="Notes / place (optional)"
          maxLength={SESSIONE_NOTE_MAX}
          disabled={azioneInCorso !== null}
          aria-label={`Notes or place for ${chiave}`}
        />
      </label>
    </div>
  );

  // --- GLI ISCRITTI (C2) ------------------------------------------------

  // L'iscritto aggiornato prende il posto del suo omonimo nell'elenco: le
  // rotte di C2 rispondono con l'iscrizione INTERA, quindi non si rilegge tutto.
  const sostituisciIscritto = (iscritto) => {
    if (!iscritto || !iscritto.id) return;
    setIscritti((precedenti) =>
      precedenti.map((p) => (p.id === iscritto.id ? iscritto : p))
    );
  };

  // ASSEGNA, SPOSTA, TOGLIE — un gesto solo, perché sul server è una scrittura
  // sola (`groupId` sull'iscrizione). Il valore vuoto vuol dire «fuori da ogni
  // gruppo». Nessuna conferma: è reversibile con lo stesso comando.
  const assegnaGruppo = (evento, iscritto, groupId) => {
    esegui(
      `gruppo-di-${iscritto.id}`,
      () =>
        api.patch(
          `/clinic-events/${evento.id}/participants/${iscritto.id}/group`,
          { groupId }
        ),
      sostituisciIscritto
    );
  };

  // IL GESTO (a) — ordinario. Una conferma sola, e il testo dice per esteso
  // ciò che NON succede: l'account dell'ospite resta. È l'informazione che
  // separa questo gesto dall'altro, e va letta prima di premere, non dopo.
  const rimuoviIscritto = (evento, iscritto) => {
    const avviso =
      iscritto.kind === "guest"
        ? `Remove ${nomeIscritto(iscritto)} from this event? The guest account stays: only this enrolment is removed.`
        : `Remove ${nomeIscritto(iscritto)} from this event?`;

    if (!window.confirm(avviso)) return;

    esegui(
      `rimuovi-${iscritto.id}`,
      () => api.del(`/clinic-events/${evento.id}/participants/${iscritto.id}`),
      () => setIscritti((precedenti) => precedenti.filter((p) => p.id !== iscritto.id))
    );
  };

  // IL GESTO (b) — serio, irreversibile, e solo sui puri ospiti.
  //
  // ⚠️ DUE PASSI, come la cancellazione di un membro (MemberProfileModal): una
  // conferma che DICE cosa sparisce, e poi la parola da DIGITARE. La parola la
  // verifica il server, che rifiuta senza di essa: questo doppio passo qui
  // serve a fermare la mano, non a proteggere i dati — quello lo fa il backend,
  // insieme alle quattro condizioni sul bersaglio (ruolo GUEST, nessuna
  // tessera, origine clinic, nessun tutore).
  const cancellaOspite = (evento, iscritto) => {
    if (!iscritto.guardianUserId) {
      setErroreAzione(
        "This enrolment has no guest account on record: remove it from the event instead."
      );
      return;
    }

    // Fetta G1: per l'adulto ospite il testo dice ciò che sparisce davvero —
    // il suo account e le sue iscrizioni; non c'è un profilo di minore. Il
    // gesto e la chiamata sono gli stessi (l'iscrizione dell'adulto porta il
    // suo id in `guardianUserId`).
    const avviso = [
      `Permanently delete the guest account of ${titolareOspite(iscritto)}?`,
      "",
      adultoOspite(iscritto)
        ? "This deletes the guest account and EVERY clinic enrolment they have, in every event. It cannot be undone."
        : "This deletes the parent/guardian account, the child profile and EVERY clinic enrolment they have, in every event. It cannot be undone.",
      "",
      "Club members are never deleted from here.",
    ].join("\n");

    if (!window.confirm(avviso)) return;

    const digitato = window.prompt(`Type "${PAROLA_CANCELLAZIONE}" to confirm:`);

    if (digitato !== PAROLA_CANCELLAZIONE) {
      setErroreAzione("Cancelled: nothing was deleted.");
      return;
    }

    esegui(
      `cancella-${iscritto.id}`,
      () =>
        api.del(`/clinic-guests/${iscritto.guardianUserId}`, {
          confirm: PAROLA_CANCELLAZIONE,
        }),
      // Sparisce una persona, e con lei possono sparire iscrizioni ad ALTRI
      // eventi: qui si rilegge l'elenco invece di toglierne una riga a mano,
      // perché l'esito vero lo conosce solo il server.
      () => caricaIscritti(evento.id)
    );
  };

  // --- L'AGGIUNTA A MANO (C2) -------------------------------------------

  // L'anagrafica, una volta sola e su richiesta (v. lo stato `anagrafica`).
  const apriAggiuntaSocio = async () => {
    setAggiunta(aggiunta === "socio" ? null : "socio");
    setErroreAzione(null);

    if (anagrafica !== null) return;

    await esegui(
      "anagrafica",
      () => api.get("/users"),
      (elenco) => setAnagrafica(Array.isArray(elenco) ? elenco : [])
    );
  };

  const aggiungiSocio = (evento, persona) => {
    esegui(
      `aggiungi-${persona.id}`,
      () => api.post(`/clinic-events/${evento.id}/participants`, { userId: persona.id }),
      (iscritto) => {
        if (iscritto && iscritto.id) setIscritti((precedenti) => [...precedenti, iscritto]);
        setRicercaSocio("");
      }
    );
  };

  // PLAYER e COACH (`eIscrivibileAllaClinic`, per ruolo — non per età, dal
  // 15/9), e non già iscritti a questo evento: sono le sole persone che il
  // server accetterebbe, e offrirne altre sarebbe promettere un rifiuto.
  // ⚠️ Niente più `dob` in questo filtro: il vecchio metro leggeva la data
  // solo nella forma stretta AAAA-MM-GG e nascondeva perfino i minori con la
  // data scritta diversamente (Causa A della ricognizione del 15/9). Il
  // candidato si offre per ruolo, non per la forma della sua data.
  const sociCercabili = () => {
    if (!Array.isArray(anagrafica)) return [];

    const cercato = ricercaSocio.trim().toLowerCase();

    if (cercato.length < 2) return [];

    const giaIscritti = new Set(iscritti.map((p) => p.childUserId).filter(Boolean));

    return anagrafica
      .filter((p) => {
        if (giaIscritti.has(p.id)) return false;
        if (!eIscrivibileAllaClinic(p)) return false;

        const nome = `${p.firstName || ""} ${p.lastName || ""}`.toLowerCase();

        return nome.includes(cercato);
      })
      .slice(0, 12);
  };

  const isOpen = evento ? evento.status === "OPEN" : false;
  const isHidden = evento ? evento.hidden === true : false;
  const gruppi = evento && Array.isArray(evento.groups) ? evento.groups : [];
  const perGruppo = conteggioPerGruppo(iscritti);

  return (
    <HomeShell backTo="/clinic-events" width="admin">
      <section className="qpsc-clinic">
        {/* Intestazione: la stessa della plancia */}
        <IntestazionePlancia />

        {caricamento && <p className="qpsc-clinic__hint">Loading…</p>}

        {/* Id inesistente o evento non leggibile: una frase sola, neutra. */}
        {!caricamento && nonDisponibile && (
          <p className="qpsc-clinic__error" role="alert">
            This event is not available.
          </p>
        )}

        {erroreAzione && (
          <p className="qpsc-clinic__error" role="alert">
            {erroreAzione}
          </p>
        )}

        {evento && bozza && (
          <>
            {/* Il titolo dell'evento e le sue pastiglie — le stesse della riga
                dell'elenco: HIDDEN accanto allo stato, mai al suo posto. */}
            <div className="qpsc-clinic__event-head">
              <h2 className="qpsc-clinic__event-title">{evento.title}</h2>

              <PastiglieEvento evento={evento} />
            </div>

            <div className="qpsc-clinic__detail">
              {/* IL LINK PUBBLICO (C1). Dipende dalla leva, che lo spegne
                  (dalla Fetta 4 la leva sta in fondo). Lo slug si chiede a
                  richiesta e si mostra nel campo di sola lettura, per
                  copiarlo a mano se gli appunti non ci sono. */}
              <div className="qpsc-clinic__groups">
                <div className="qpsc-clinic__block-label">
                  <FaLink aria-hidden="true" /> Public link
                </div>

                <p className="qpsc-clinic__hint">
                  Share this link with parents and guardians outside the club: from it
                  they enrol a child, or themselves if 18 or over, and receive a sign-in
                  link by email. It works only
                  while the event is open.
                </p>

                {linkPubblico && (
                  <input
                    type="text"
                    className="qpsc-input"
                    value={linkPubblico}
                    readOnly
                    onFocus={(e) => e.target.select()}
                    aria-label="Public link"
                  />
                )}

                <div className="qpsc-clinic__dates-add">
                  <button
                    type="button"
                    className="qpsc-ghost-btn"
                    onClick={() => mostraLink(evento, false)}
                    disabled={azioneInCorso !== null}
                  >
                    <FaLink aria-hidden="true" />
                    <span>
                      {azioneInCorso === `link-${evento.id}`
                        ? "Loading…"
                        : linkCopiato
                        ? "Copied"
                        : linkPubblico
                        ? "Copy link again"
                        : "Copy public link"}
                    </span>
                  </button>

                  {linkPubblico && (
                    <button
                      type="button"
                      className="qpsc-ghost-btn"
                      onClick={() => mostraLink(evento, true)}
                      disabled={azioneInCorso !== null}
                    >
                      <FaSyncAlt aria-hidden="true" />
                      <span>New link</span>
                    </button>
                  )}
                </div>
              </div>

              {/* MODIFICA */}
              <label className="qpsc-field">
                <span className="qpsc-field__label">Title</span>
                <input
                  type="text"
                  className="qpsc-input"
                  value={bozza.title}
                  onChange={(e) => setBozza({ ...bozza, title: e.target.value })}
                  maxLength={120}
                  disabled={azioneInCorso !== null}
                />
              </label>

              <label className="qpsc-field">
                <span className="qpsc-field__label">Description</span>
                <textarea
                  className="qpsc-input qpsc-clinic__textarea"
                  value={bozza.description}
                  onChange={(e) =>
                    setBozza({ ...bozza, description: e.target.value })
                  }
                  maxLength={2000}
                  rows={3}
                  disabled={azioneInCorso !== null}
                />
              </label>

              <button
                type="button"
                className="qpsc-tool-btn"
                onClick={() => salvaModifica(evento)}
                disabled={azioneInCorso !== null}
              >
                <span>
                  {azioneInCorso === "modifica" ? "Saving…" : "Save changes"}
                </span>
              </button>

              {/* I GRUPPI */}
              <div className="qpsc-clinic__groups">
                <div className="qpsc-clinic__block-label">
                  <FaUsers aria-hidden="true" /> Groups
                </div>

                {/* L'errore di lettura delle sessioni sta in testa ai gruppi,
                    che le contengono. */}
                {erroreSessioni && (
                  <p className="qpsc-clinic__error">{erroreSessioni}</p>
                )}

                {gruppi.length === 0 ? (
                  <p className="qpsc-clinic__hint">
                    No groups yet. Groups divide the people in this event; they are
                    not club teams.
                  </p>
                ) : (
                  <ul className="qpsc-clinic__grouplist">
                    {gruppi.map((gruppo) => (
                      <React.Fragment key={gruppo.id}>
                        <li className="qpsc-clinic__group">
                          <span className="qpsc-clinic__group-name">{gruppo.name}</span>

                          {/* IL CONTATORE DEL GRUPPO (15/9): quanti
                              iscritti portano questo `groupId`. Si
                              aggiorna con `iscritti`, cioè a ogni
                              assegnazione o spostamento. */}
                          <span className="qpsc-clinic__count">
                            {perGruppo.get(gruppo.id) || 0} enrolled
                          </span>

                          <button
                            type="button"
                            className="qpsc-clinic__group-act"
                            onClick={() => rinominaGruppo(evento, gruppo)}
                            disabled={azioneInCorso !== null}
                          >
                            Rename
                          </button>

                          <button
                            type="button"
                            className="qpsc-clinic__group-act qpsc-clinic__group-act--danger"
                            onClick={() => rimuoviGruppo(evento, gruppo)}
                            disabled={azioneInCorso !== null}
                            aria-label={`Remove group ${gruppo.name}`}
                          >
                            <FaTrash aria-hidden="true" />
                          </button>
                        </li>

                        {/* LE SESSIONI DEL GRUPPO (Calendario clinic,
                            Fetta 1): una riga sotto la riga del gruppo,
                            che resta com'era. In ordine di giorno e ora
                            (lo dà il server); aggiunta, modifica in linea
                            e cancellazione vera. */}
                        {(() => {
                          const proprie = sessioni.filter((s) => s.groupId === gruppo.id);
                          const nuova = bozzaSessioneDi(gruppo.id);

                          return (
                            <li className="qpsc-clinic__sessions">
                              <div className="qpsc-clinic__sessions-head">
                                Sessions
                                {!caricamentoSessioni && !erroreSessioni && ` (${proprie.length})`}
                              </div>

                              {caricamentoSessioni && (
                                <p className="qpsc-clinic__hint">Loading…</p>
                              )}

                              {!caricamentoSessioni && !erroreSessioni && proprie.length === 0 && (
                                <p className="qpsc-clinic__hint">No sessions yet.</p>
                              )}

                              {proprie.length > 0 && (
                                <ul className="qpsc-clinic__session-list">
                                  {proprie.map((s) =>
                                    modificaSessione && modificaSessione.id === s.id ? (
                                      <li
                                        key={s.id}
                                        className="qpsc-clinic__session qpsc-clinic__session--edit"
                                      >
                                        {campiSessione(
                                          modificaSessione,
                                          (campo, valore) =>
                                            setModificaSessione({
                                              ...modificaSessione,
                                              [campo]: valore,
                                            }),
                                          "this session"
                                        )}

                                        <div className="qpsc-clinic__dates-add">
                                          <button
                                            type="button"
                                            className="qpsc-ghost-btn"
                                            onClick={() => salvaSessione(evento)}
                                            disabled={
                                              azioneInCorso !== null ||
                                              !modificaSessione.date ||
                                              !modificaSessione.startTime
                                            }
                                          >
                                            <span>
                                              {azioneInCorso === `sessione-${s.id}`
                                                ? "Saving…"
                                                : "Save session"}
                                            </span>
                                          </button>

                                          <button
                                            type="button"
                                            className="qpsc-ghost-btn"
                                            onClick={() => setModificaSessione(null)}
                                            disabled={azioneInCorso !== null}
                                          >
                                            <span>Discard changes</span>
                                          </button>
                                        </div>
                                      </li>
                                    ) : (
                                      <li key={s.id} className="qpsc-clinic__session">
                                        <span className="qpsc-clinic__session-main">
                                          <span className="qpsc-clinic__session-when">
                                            {dataLeggibile(s.date)} · {orarioSessione(s)}
                                          </span>
                                          {s.notes && (
                                            <span className="qpsc-clinic__session-notes">
                                              {s.notes}
                                            </span>
                                          )}
                                        </span>

                                        <button
                                          type="button"
                                          className="qpsc-clinic__session-act"
                                          onClick={() => avviaModificaSessione(s)}
                                          disabled={azioneInCorso !== null}
                                        >
                                          Edit
                                        </button>

                                        <button
                                          type="button"
                                          className="qpsc-clinic__session-act qpsc-clinic__session-act--danger"
                                          onClick={() => cancellaSessione(evento, s)}
                                          disabled={azioneInCorso !== null}
                                        >
                                          {azioneInCorso === `sessione-${s.id}`
                                            ? "Cancelling…"
                                            : "Cancel session"}
                                        </button>
                                      </li>
                                    )
                                  )}
                                </ul>
                              )}

                              {/* Il modulo d'aggiunta del gruppo: una
                                  sessione alla volta (D4), niente
                                  ripetizioni automatiche. */}
                              <div className="qpsc-clinic__session-new">
                                {campiSessione(
                                  nuova,
                                  (campo, valore) =>
                                    poniBozzaSessione(gruppo.id, campo, valore),
                                  `group ${gruppo.name}`
                                )}

                                <button
                                  type="button"
                                  className="qpsc-ghost-btn"
                                  onClick={() => aggiungiSessione(evento, gruppo)}
                                  disabled={
                                    azioneInCorso !== null ||
                                    !nuova.date ||
                                    !nuova.startTime
                                  }
                                >
                                  <FaPlus aria-hidden="true" />
                                  <span>
                                    {azioneInCorso === `sessione-nuova-${gruppo.id}`
                                      ? "Adding…"
                                      : "Add session"}
                                  </span>
                                </button>
                              </div>
                            </li>
                          );
                        })()}

                        {/* LA BACHECA DEL GRUPPO («BOARD - CHAT» Fetta A,
                            26/9/2026), sotto le sessioni. Si legge anche a
                            evento chiuso o nascosto (BAC-6); si scrive solo a
                            evento aperto; «Delete» su ogni messaggio è
                            moderazione e resta sempre. L'admin scrive col
                            proprio nome e ruolo (BAC-9). */}
                        <li className="qpsc-clinic__sessions">
                          <div className="qpsc-clinic__board-head">
                            <span className="qpsc-clinic__sessions-head">
                              <FaComments aria-hidden="true" /> BOARD - CHAT
                            </span>
                            <button
                              type="button"
                              className="qpsc-clinic__session-act"
                              onClick={() => apriChiudiBacheca(gruppo.id)}
                              aria-expanded={bachecheAperte.includes(gruppo.id)}
                            >
                              {bachecheAperte.includes(gruppo.id) ? "Close board" : "Open board"}
                            </button>
                          </div>

                          {bachecheAperte.includes(gruppo.id) && (
                            <BachecaClinic
                              percorso={`/clinic-events/${encodeURIComponent(evento.id)}/groups/${encodeURIComponent(gruppo.id)}/board`}
                              percorsoMessaggio={(idMessaggio) =>
                                `/clinic-events/${encodeURIComponent(evento.id)}/groups/${encodeURIComponent(gruppo.id)}/board/${encodeURIComponent(idMessaggio)}`
                              }
                              amministrazione
                              scritturaAperta={isOpen}
                            />
                          )}
                        </li>
                      </React.Fragment>
                    ))}

                    {/* CHI NON STA IN NESSUN GRUPPO — la chiave vuota
                        del conteggio. Si mostra solo se ci sono gruppi:
                        senza gruppi «senza gruppo» sarebbe il totale. */}
                    <li className="qpsc-clinic__group qpsc-clinic__group--nogroup">
                      <span className="qpsc-clinic__group-name">No group</span>
                      <span className="qpsc-clinic__count">
                        {perGruppo.get("") || 0} enrolled
                      </span>
                    </li>
                  </ul>
                )}

                <div className="qpsc-clinic__dates-add">
                  <input
                    type="text"
                    className="qpsc-input"
                    value={nuovoGruppo}
                    onChange={(e) => setNuovoGruppo(e.target.value)}
                    placeholder="Group name"
                    maxLength={60}
                    disabled={azioneInCorso !== null}
                    aria-label="New group name"
                  />
                  <button
                    type="button"
                    className="qpsc-ghost-btn"
                    onClick={() => creaGruppo(evento)}
                    disabled={azioneInCorso !== null}
                  >
                    <FaPlus aria-hidden="true" />
                    <span>
                      {azioneInCorso === "gruppo-nuovo" ? "Adding…" : "Add group"}
                    </span>
                  </button>
                </div>

                {/* Si dice PRIMA di premere «Remove»: da C2 un gruppo
                    abitato non si cancella, e il perché è che gli
                    iscritti ci sono dentro davvero. Da Fetta 1 del
                    calendario anche le SESSIONI trattengono un gruppo
                    (D5): si dice qui, prima di premere il cestino. */}
                {gruppi.length > 0 && (
                  <p className="qpsc-clinic__hint">
                    A group with people or sessions in it cannot be removed: move
                    the people to another group, or out of any group, and cancel
                    its sessions first.
                  </p>
                )}
              </div>

              {/* GLI ISCRITTI (C2) */}
              <div className="qpsc-clinic__groups">
                <div className="qpsc-clinic__block-label">
                  <FaUserFriends aria-hidden="true" /> Participants
                  {/* IL TOTALE DELL'EVENTO (15/9): sempre, anche «(0)»,
                      appena l'elenco è arrivato — un numero che
                      compare solo quando è maggiore di zero non si
                      distingue da un numero non ancora letto. */}
                  {!caricamentoIscritti && !erroreIscritti && ` (${iscritti.length})`}
                </div>

                {erroreIscritti && (
                  <p className="qpsc-clinic__error">{erroreIscritti}</p>
                )}

                {caricamentoIscritti && (
                  <p className="qpsc-clinic__hint">Loading…</p>
                )}

                {!caricamentoIscritti && !erroreIscritti && iscritti.length === 0 && (
                  <p className="qpsc-clinic__hint">
                    Nobody is enrolled in this event yet.
                  </p>
                )}

                {iscritti.length > 0 && (
                  <ul className="qpsc-clinic__people">
                    {iscritti.map((p) => (
                      <li key={p.id} className="qpsc-clinic__person">
                        <div className="qpsc-clinic__person-main">
                          <span className="qpsc-clinic__person-name">
                            {nomeIscritto(p)}
                          </span>
                          <span className="qpsc-clinic__person-meta">
                            {sottotitoloIscritto(p)}
                          </span>
                        </div>

                        {/* Il gruppo. Un solo comando per assegnare,
                            spostare e togliere: sul server è una
                            scrittura sola, e qui è una scelta sola. */}
                        <select
                          className="qpsc-input qpsc-clinic__select"
                          value={p.groupId || ""}
                          onChange={(e) => assegnaGruppo(evento, p, e.target.value)}
                          disabled={azioneInCorso !== null || gruppi.length === 0}
                          aria-label={`Group for ${nomeIscritto(p)}`}
                        >
                          <option value="">No group</option>
                          {gruppi.map((gruppo) => (
                            <option key={gruppo.id} value={gruppo.id}>
                              {gruppo.name}
                            </option>
                          ))}
                        </select>

                        <button
                          type="button"
                          className="qpsc-clinic__group-act"
                          onClick={() => rimuoviIscritto(evento, p)}
                          disabled={azioneInCorso !== null}
                        >
                          {azioneInCorso === `rimuovi-${p.id}`
                            ? "Removing…"
                            : "Remove"}
                        </button>

                        {/* Il gesto (b): solo sugli OSPITI, mai su un
                            tesserato del club. Il server lo rifiuterebbe
                            comunque — quattro condizioni sul bersaglio —
                            ma un pulsante che non deve mai essere premuto
                            non si disegna. */}
                        {p.kind === "guest" && (
                          <button
                            type="button"
                            className="qpsc-clinic__group-act qpsc-clinic__group-act--danger"
                            onClick={() => cancellaOspite(evento, p)}
                            disabled={azioneInCorso !== null}
                            aria-label={`Delete guest ${titolareOspite(p)} permanently`}
                          >
                            <FaUserSlash aria-hidden="true" />
                          </button>
                        )}

                        {/* «Payments» e «View Profile» (Fetta 5), ultimi
                            della riga e nell'ordine della User List, con le
                            sue classi (§5.3 fantasma, §5.4 View Profile).
                            Senza le varianti `--wide`: sotto i 768px
                            metterebbero ciascun pulsante a piena larghezza,
                            uno sotto l'altro, e qui i due vanno a capo
                            insieme, a destra (ClinicEvents.css, in coda).
                            «View Profile» porta alla scheda come nella User
                            List, e si accende solo per un socio, con l'id
                            della sua scheda (`childUserId`): un ospite non
                            ha una scheda del club da aprire.
                            Fetta 7: prima di «Payments» il SALDO dell'evento
                            (quota − pagamenti, o «Not due»), e «Payments» è
                            acceso su ogni riga, soci e ospiti: apre la
                            finestra «Event payment» di quell'iscrizione. */}
                        <div className="qpsc-clinic__person-actions">
                          {(() => {
                            const saldo = saldoDellIscritto(p);
                            return (
                              <span
                                className={`qpsc-clinic__balance qpsc-clinic__balance--${saldo.tono}`}
                                aria-label={`Balance for ${nomeIscritto(p)}: ${saldo.testo}`}
                              >
                                {saldo.testo}
                              </span>
                            );
                          })()}
                          <button
                            type="button"
                            className="qpsc-ghost-btn"
                            onClick={() => setPagamentiDi(p.id)}
                            disabled={azioneInCorso !== null}
                          >
                            Payments
                          </button>
                          {/* Fetta G1: sulle righe degli OSPITI, allo stesso
                              posto e con la stessa classe, «View Guest» —
                              acceso — apre la finestra di sola lettura
                              «Guest details». Sulle righe dei soci «View
                              Profile» resta com'era. */}
                          {p.kind === "guest" ? (
                            <button
                              type="button"
                              className="qpsc-profile-btn"
                              onClick={() => setSchedaOspiteDi(p.id)}
                            >
                              View Guest
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="qpsc-profile-btn"
                              onClick={() => navigate(`/profile/${p.childUserId}`)}
                              disabled={!p.childUserId}
                            >
                              View Profile
                            </button>
                          )}
                        </div>
                      </li>
                    ))}
                  </ul>
                )}

                {/* L'AGGIUNTA A MANO — il solo socio del club. «Add a
                    guest» è stato tolto dalla Fetta G1: gli ospiti si
                    iscrivono da sé dal link pubblico. */}
                <div className="qpsc-clinic__dates-add">
                  <button
                    type="button"
                    className="qpsc-ghost-btn"
                    onClick={apriAggiuntaSocio}
                    disabled={azioneInCorso !== null || !isOpen}
                  >
                    <FaUserPlus aria-hidden="true" />
                    <span>
                      {azioneInCorso === "anagrafica"
                        ? "Loading…"
                        : "Add a club member"}
                    </span>
                  </button>
                </div>

                {/* Perché il comando è spento a evento chiuso: si
                    AGGIUNGE solo a evento aperto — è la leva del confine
                    — mentre chi è già dentro si gestisce sempre. */}
                {!isOpen && (
                  <p className="qpsc-clinic__hint">
                    The event is closed: reopen it to add people. Groups and
                    removals work either way.
                  </p>
                )}

                {aggiunta === "socio" && isOpen && (
                  <div className="qpsc-clinic__add">
                    <label className="qpsc-field">
                      <span className="qpsc-field__label">
                        Search a player or coach by name
                      </span>
                      <input
                        type="text"
                        className="qpsc-input"
                        value={ricercaSocio}
                        onChange={(e) => setRicercaSocio(e.target.value)}
                        placeholder="At least two letters"
                        disabled={azioneInCorso !== null}
                      />
                    </label>

                    <p className="qpsc-clinic__hint">
                      Only players and coaches are listed, and only those not
                      already enrolled in this event.
                    </p>

                    <ul className="qpsc-clinic__grouplist">
                      {sociCercabili().map((persona) => (
                        <li key={persona.id} className="qpsc-clinic__group">
                          <span className="qpsc-clinic__group-name">
                            {`${persona.firstName || ""} ${persona.lastName || ""}`.trim()}
                          </span>

                          <button
                            type="button"
                            className="qpsc-clinic__group-act"
                            onClick={() => aggiungiSocio(evento, persona)}
                            disabled={azioneInCorso !== null}
                          >
                            {azioneInCorso === `aggiungi-${persona.id}`
                              ? "Adding…"
                              : "Add"}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              {/* IN FONDO (Fetta 4): la leva apri/chiudi e «Hide», o «Unhide»
                  per un evento nascosto. Spostata qui intera dalla cima della
                  pagina; il filo in testa la separa dagli iscritti. */}
              <div className="qpsc-clinic__groups qpsc-clinic__lever">
                {isHidden ? (
                  <>
                    {/* «UNHIDE» (15/9). Su un evento nascosto la leva
                        apri/chiudi non si disegna: il server rifiuterebbe
                        comunque di riaprirlo, e prima si torna in vista. */}
                    <button
                      type="button"
                      className="qpsc-tool-btn"
                      onClick={() => cambiaVisibilita(evento, false)}
                      disabled={azioneInCorso !== null}
                    >
                      <FaEye aria-hidden="true" />
                      <span>
                        {azioneInCorso === `nascosto-${evento.id}`
                          ? "Saving…"
                          : "Unhide event"}
                      </span>
                    </button>

                    <p className="qpsc-clinic__hint">
                      The event is hidden from the list and closed. Nothing has been
                      deleted: enrolments and groups are intact. Unhide it to bring it
                      back into view; it can then be reopened.
                    </p>
                  </>
                ) : (
                  <>
                    {/* LA LEVA */}
                    <button
                      type="button"
                      className={isOpen ? "qpsc-ghost-btn" : "qpsc-tool-btn"}
                      onClick={() => cambiaStato(evento)}
                      disabled={azioneInCorso !== null}
                    >
                      {isOpen ? (
                        <FaLock aria-hidden="true" />
                      ) : (
                        <FaLockOpen aria-hidden="true" />
                      )}
                      <span>
                        {azioneInCorso === `stato-${evento.id}`
                          ? "Saving…"
                          : isOpen
                          ? "Close event"
                          : "Reopen event"}
                      </span>
                    </button>

                    <p className="qpsc-clinic__hint">
                      {isOpen
                        ? "The event is open: the public link works. Closing it makes it inactive and switches the link off; it can be reopened."
                        : "The event is inactive: the public link does not work. Reopening it makes it active again."}
                    </p>

                    {/* «HIDE» (15/9): solo su un evento CHIUSO, per decisione
                        del committente — non si toglie dalla vista un evento
                        con le iscrizioni aperte e il link vivo. Fantasma,
                        come ogni gesto che non è il principale. */}
                    {!isOpen && (
                      <>
                        <button
                          type="button"
                          className="qpsc-ghost-btn"
                          onClick={() => cambiaVisibilita(evento, true)}
                          disabled={azioneInCorso !== null}
                        >
                          <FaEyeSlash aria-hidden="true" />
                          <span>
                            {azioneInCorso === `nascosto-${evento.id}`
                              ? "Saving…"
                              : "Hide event"}
                          </span>
                        </button>

                        <p className="qpsc-clinic__hint">
                          Hiding removes the event from the events list only. Nothing
                          is deleted — enrolments and groups stay — and you can unhide
                          it here, or find it in the list with “Show hidden events”.
                        </p>
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </>
        )}
      </section>

      {/* LA FINESTRA DEI PAGAMENTI (Fetta 7). La riga si rilegge dall'elenco:
          se l'iscrizione non c'è più, la finestra non si disegna. */}
      {evento &&
        pagamentiDi &&
        (() => {
          const iscritto = iscritti.find((p) => p.id === pagamentiDi);
          return iscritto ? (
            <ClinicPaymentModal
              key={iscritto.id}
              idEvento={evento.id}
              iscritto={iscritto}
              onAggiorna={sostituisciIscritto}
              onClose={() => setPagamentiDi(null)}
            />
          ) : null;
        })()}

      {/* LA SCHEDA DELL'OSPITE (Fetta G1), sola lettura. Stessa regola della
          finestra dei pagamenti: se l'iscrizione non c'è più, non si disegna. */}
      {evento &&
        schedaOspiteDi &&
        (() => {
          const iscritto = iscritti.find((p) => p.id === schedaOspiteDi);
          return iscritto ? (
            <ClinicGuestModal
              key={iscritto.id}
              idEvento={evento.id}
              iscritto={iscritto}
              onClose={() => setSchedaOspiteDi(null)}
            />
          ) : null;
        })()}
    </HomeShell>
  );
}
